import React from 'react';
import { IconChart } from '../../../../components/Icons';
import ChartModule from './ChartModule';

/**
 * Chart Module Configuration
 *
 * Defines the static properties of the Chart module for the right panel
 */
const chartModuleConfig = {
  id: 'chart',
  name: 'Chart & Transactions',
  icon: <IconChart />,
  component: ChartModule,
  enabled: false,
  expandEnabled: true,
  defaultExpanded: false,
  keyboardShortcut: 'g',
  order: 1,
};

export default chartModuleConfig;
